import r from "../managers/braze-instance.js";
import { keys as C } from "../util/code-utils.js";
import { logger as N, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
export function wipeData() {
  const o = r.j();
  if (null == o) return void N.warn(w);
  o.clearData();
  const t = C(et.Ds);
  for (let o = 0; o < t.length; o++) {
    const n = t[o],
      r = et.Ds[n];
    new et(r, N).clearData();
  }
  if (r.rr()) for (const o of r.lr()) o.clearData(!0);
  const n = r.g();
  n && n.fo();
}
